// import logo from "./logo.svg";
import "./App.css";
import "//unpkg.com/mathlive";
import "//unpkg.com/@cortex-js/compute-engine?module";
import { ComputeEngine } from "https://unpkg.com/@cortex-js/compute-engine?module";
import { useState, useEffect } from "react";

const ce = new ComputeEngine();

// const mathVirtualKeyboard = window.mathVirtualKeyboard;

function App() {
  const [value, setValue] = useState("");

  // useEffect(() => {
  //   const mathField = document.querySelector("math-field");
  //   if (mathField) {
  //     // mathVirtualKeyboard.layouts = ["compact"];
  //     // mathVirtualKeyboard.show();
  //   }
  // }, []);

  const mathInput = (evt) => {
    setValue(evt.target.value);
  };

  const mathBeforeInput = (evt) => {
    const op = evt.data;
    if (op === "=") {
      evt.preventDefault();
      const mathField = evt.target;
      const mfValue = mathField.value;
      const lastEqual = mfValue.lastIndexOf("=");
      let exp = mfValue;
      if (lastEqual !== -1) {
        exp = mathField.value.substring(lastEqual + 1, mfValue.length);
      }

      try {
        const result = ce.parse(exp).evaluate().value;
        console.log(result);
        setValue(value + " = " + result);
      } catch (e) {
        console.error(e);
        setValue(value + " = Error");
      }
    }
  };

  const calc_funcs = [
    {
      display: "+",
      command: "+",
    },
    {
      display: "-",
      command: "-",
    },
    {
      display: "*",
      command: "*",
    },
    {
      display: "/",
      command: "/",
    },
    {
      display: "^2",
      command: "^2",
    },
    {
      display: "√",
      command: "\\sqrt{#0}",
    },
    {
      display: "(",
      command: "(",
    },
    {
      display: ")",
      command: ")",
    },
    {
      display: "=",
      command: "=",
    },
  ];

  return (
    <div>
      <div
        id="kbd_container"
        style={{ display: "flex", margin: "0 0 16px 0", gap: "8px" }}
      >
        {calc_funcs.map((op) => (
          <button
            key={op.command}
            onClick={() => {
              const mathField = document.querySelector("math-field");
              mathField.executeCommand(["insert", op.command]);
              mathField.focus();
            }}
          >
            {op.display}
          </button>
        ))}
      </div>
      <math-field
        onInput={mathInput}
        onBeforeInput={mathBeforeInput}
        style={{ width: "calc(100% - 32px)" }}
      >
        {value}
      </math-field>
      <p>
        <b>Expression Value: </b> {value}
      </p>
      <button
        onClick={() => {
          const mathField = document.querySelector("math-field");
          mathField.executeCommand(["copyToClipboard"]);
        }}
      >
        Copy
      </button>
    </div>
  );
}

export default App;
